import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Skeleton, Stack, Typography } from "@mui/material";
import { Storage, CheckCircle, ErrorOutline, Computer } from "@mui/icons-material";
const StatisticsPanel = ({ stats, loading }) => (
  <Box component="section" aria-label="Resumen general de readers" sx={{ p: 2.5 }}>
    <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" gap={1} mb={1.5}>
      <Typography variant="body2" fontWeight={700} sx={{ color: "#334155" }}>
        Resumen general
      </Typography>
      <Typography variant="caption" sx={{ color: "#526579" }}>
        {loading
          ? "Actualizando conteos…"
          : `${stats.uniqueCommerces || 0} comercios · ${stats.totalAntennas || 0} antenas · ${
              stats.readersOnCooldown || 0
            } readers en espera`}
      </Typography>
    </Stack>
    <Grid container spacing={1.5}>
      {[
        ["Grupos", stats.totalGroups, Storage, "#edf3fa", "#35617d"],
        ["Readers", stats.totalReaders, Computer, "#f3f6f9", "#40576d"],
        ["Activos", stats.activeReaders, CheckCircle, "#edf8f2", "#237849"],
        ["Inactivos", stats.inactiveReaders, ErrorOutline, "#fff1f2", "#ae3b48"],
      ].map(([label, value, Icon, background, color]) => (
        <Grid item xs={6} md={3} key={label}>
          <Stack
            direction="row"
            alignItems="center"
            gap={1.5}
            sx={{ p: 2, bgcolor: background, border: `1px solid ${color}25`, borderRadius: 2 }}
          >
            <Icon sx={{ color, fontSize: 24 }} />
            <Box>
              <Typography variant="caption" sx={{ color: "#526579" }}>
                {label}
              </Typography>
              {loading ? (
                <Skeleton width={70} height={32} />
              ) : (
                <Typography variant="h5" sx={{ color, fontWeight: 700 }}>
                  {Number(value || 0).toLocaleString("es-CO")}
                </Typography>
              )}
            </Box>
          </Stack>
        </Grid>
      ))}
    </Grid>
  </Box>
);
StatisticsPanel.propTypes = { stats: PropTypes.object.isRequired, loading: PropTypes.bool };
export default React.memo(StatisticsPanel);
